<template>
  <b-card style="padding:40px;">
    <h5><b>CREATE PRODUCT</b></h5>
    <hr />
    <b-row>
      <b-col md="6">
        <b-form-group>
          <label :for="`input-name`"
            >Name <span class="danger-new">*</span></label
          >
          <b-form-input
            v-model="form.name"
            :id="`input-name`"
            :type="`text`"
            class="input-new"
          ></b-form-input>
          <p v-if="error.name">
            <span class="danger-new">{{ this.error.name }}</span>
          </p>
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group>
          <label :for="`input-size`">Size</label>
          <b-form-input
            v-model="form.size"
            :id="`input-size`"
            :type="`text`"
            class="input-new"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="6">
        <b-form-group>
          <label :for="`input-size`">Type</label>
          <b-form-select
            v-model="form.proCat"
            :options="select.proCat"
            class="input-new"
            required
          ></b-form-select>
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group>
          <label :for="`input-size`">Volume (ml)</label>
          <b-form-input
            v-model="form.volume"
            :id="`input-size`"
            :type="`number`"
            class="input-new"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="12">
        <b-form-file v-model="form.image" class="mt-3" plain></b-form-file>
      </b-col>
    </b-row>
    <br />
    <b-row align="right">
      <b-col>
        <b-button variant="primary" size="sm" @click="onClickBack">
          BACK </b-button
        >&nbsp;&nbsp;&nbsp;
        <b-button variant="primary" size="sm" @click="onClickSaving">
          SAVE
        </b-button>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
export default {
  data() {
    return {
      form: {
        name: "",
        size: "",
        image: null,
        proCat: "1",
        volume: ""
      },

      select: {
        proCat: [
          { text: "UHT", value: "1" },
          { text: "Pasteurized", value: "2" }
        ]
      },

      error: {
        name: ""
      }
    };
  },
  methods: {
    onClickBack() {
      this.$router.go(-1);
    },
    onClickSaving() {
      this.checkForm();

      let form = new FormData();
      form.set("name", this.form.name);
      form.set("size", this.form.size);
      form.set("product_id", "");
      form.set("milliliter", this.form.volume);
      form.set("type", parseInt(this.form.proCat));
      if (this.form.image !== null) {
        form.set("image", this.form.image);
      } else {
        form.set("milliliter", "");
      }

      this.$store.dispatch("createProduct", form).then(res => {
        if (res.data.response.code === 1) {
          this.$router.go(-1);
        }
      });
    },
    checkForm: function(e) {
      if (this.form.name) return true;
      this.error.name = "";
      if (!this.form.name) this.error.name = "Name required.";
      e.preventDefault();
    }
  }
};
</script>
<style lang="css" scoped></style>
